import styled from 'styled-components';
import BaseTable from 'react-base-table';

export const Wrapper = styled.div`
	width: 100%;
  flex: 1;
`;

export const Sample = styled.div`
	height: 100%;
	width: 100%;
`;

export const BadgeWrapper = styled.div<{ color: string, bgColor: string  }>`
	display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.bgColor};
  width: 70px;
  height: 22px;
  border-radius: 8px;
  border: solid 1px ${(props) => props.color};
  color: ${(props) => props.color};
  font-size: 0.9em;
  margin: 5px 0px;
`;

export const BadgeStyle = styled.div<{ color: string }>`
  border-radius: 15px;
  height: 5px;
  width: 13px;
  margin-right: 5px;
	background-color: ${(props) => props.color};
`;

export const BadgeText = styled.div`
  font-size: 10px;
`;

export const StyledBaseTable = styled(BaseTable)`
  font-size: 16px;
  border: none;
  box-shadow: none;
  .BaseTable__table-main{
    outline: none;
  }
  .BaseTable__row {
    padding: 15px;
    font-size: 16px;
  }
  .BaseTable__header-row {
    border-bottom: none;
    outline: none;
    padding: 0px 15px;
  }
  .BaseTable__header-cell {
    font-weight: bold;
  }
`;
